import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReviewHistoryCard from "components/card/ReviewHistoryCard";
import {
  getPendingPerfReviewList
} from "../../../../../redux/performancereview/performanceReviewState";


const ReviewHistoryTable = () => {
	
const dispatch = useDispatch();
	
	useEffect(() => {
		dispatch(getPendingPerfReviewList({completed: 1}));
	},[dispatch]);

	const recordList = useSelector((state) => state.performanceReview.pendingPerfReviewList.items);

return (
	<div className="grid grid-cols-1 gap-3 p-1 h-[600px] overflow-y-auto">

		<div className="space-y-4">
			{recordList.map((record, index) => (
				<ReviewHistoryCard key={`review_history_${index}`} recordData={record}
					name="Jennifer Lee"
					reviewPeriod="Q2 2025"
					overallRating="4.5"
					reviewDate="July 15, 2025"
					reviewedBy="John Smith"
				/>
			))}
			
		</div>

	</div>
  );
};

export default ReviewHistoryTable;
